import { makeActionCreator } from '../../../../utilities'
import { ImagingUltrasoundConstants } from './imagingUltrasound.constants'

export const setType = makeActionCreator(ImagingUltrasoundConstants.SET_TYPE, 'imageType')
export const saveImagingUltrasound = makeActionCreator(ImagingUltrasoundConstants.SAVE_IMAGING_ULTRASOUND)
export const resetState = makeActionCreator(ImagingUltrasoundConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(ImagingUltrasoundConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(ImagingUltrasoundConstants.SET_STATE, 'imagingUltrasoundState')
export const setDateTime = makeActionCreator(ImagingUltrasoundConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(ImagingUltrasoundConstants.SET_ASSESSED_BY, 'assessedBy')
export const setUpdateInputRows = makeActionCreator(ImagingUltrasoundConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setRolePerforming = makeActionCreator(ImagingUltrasoundConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setLocation = makeActionCreator(ImagingUltrasoundConstants.SET_LOCATION, 'location')
export const setFindings = makeActionCreator(ImagingUltrasoundConstants.SET_FINDINGS, 'findings')
export const setSaveResponse = makeActionCreator(ImagingUltrasoundConstants.SET_SAVE_RESPONSE, 'saveResponse')
export const setImagingUltrasoundComplications = makeActionCreator(
  ImagingUltrasoundConstants.SET_PROCEDURE_COMPLICATIONS,
  'procedureComplications'
)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
